import { createContext } from 'react';

export const VerificationContext = createContext({});
